import {Button, CardMedia, Grid, Toolbar} from "@mui/material";
import {MenuOutlined} from "@mui/icons-material";
import {UI_ACTION_CREATORS} from "../../redux/features/ui/ui-slice";
import {useDispatch} from "react-redux";
import logo from "../../assets/images/logo.png";
import {Link} from "react-router-dom";

const MobileHeader = () => {
    const dispatch = useDispatch();
    return (
        <Toolbar>
            <Grid container={true} justifyContent="space-between" alignItems="center">
                <Grid item={true} xs="auto">
                    <MenuOutlined
                        onClick={() => dispatch(UI_ACTION_CREATORS.toggleDrawer(true))}
                        sx={{
                            borderWidth: 1,
                            borderColor: "icon.border",
                            borderStyle: "solid",
                            backgroundColor: "icon.background",
                            fontSize: 32,
                            padding: 0.5,
                            color: "icon.secondary",
                            borderRadius: "25%"
                        }}
                    />
                </Grid>
                <Grid item={true} xs="auto">
                    <Link to="/" style={{textDecoration: "none"}}>
                        <CardMedia
                            component="img"
                            sx={{height: 40, objectFit: "contain", width: 150}}
                            src={logo}
                        />
                    </Link>
                </Grid>
                <Grid item={true} xs="auto">
                    <Link to="/apply" style={{textDecoration: "none"}}>
                        <Button
                            variant="contained"
                            size="small"
                            color="secondary"
                            disableElevation={true}
                            sx={{textTransform: "none"}}>
                            Apply Now
                        </Button>
                    </Link>
                </Grid>
            </Grid>
        </Toolbar>
    )
}

export default MobileHeader;